import { AuthClientTokens } from '@/hooks/useKeyCloak'
import { HYDRATE } from 'next-redux-wrapper'

import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import type { AppState } from '../store'
import type { HydratePayload } from '../types/hydrate'

export interface TokenStateIProps {
  token: string | null
  idToken: string | null
  refreshToken: string | null
}

const initialState: TokenStateIProps = {
  token: null,
  idToken: null,
  refreshToken: null,
}

export const tokenSlice = createSlice({
  name: 'token',
  initialState,
  reducers: {
    setAuthTokens: (state, action: PayloadAction<AuthClientTokens>) => {
      state.token = action?.payload?.token || null
      state.idToken = action?.payload?.idToken || null
      state.refreshToken = action?.payload?.refreshToken || null
    },
    clearAuthTokens: (state) => {
      state.token = null
      state.idToken = null
      state.refreshToken = null
    },
  },
  extraReducers: (builder) => {
    builder.addCase(HYDRATE, (state, action) => {
      const hydrateAction = action as PayloadAction<
        HydratePayload<TokenStateIProps>
      >
      return {
        ...state,
        ...hydrateAction.payload.subject,
      }
    })
  },
})

export const { setAuthTokens, clearAuthTokens } = tokenSlice.actions

export const selectTokens = (state: AppState) => state.token
export const selectHasToken = (state: AppState) => !!state.token.token

// eslint-disable-next-line import/no-default-export
export default tokenSlice.reducer
